import './SharedDataDictionaryView.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { GatewayContent } from '../../gateway/general';
import { NoData } from '@ui/NoData';
import { PoweredByArovy } from '@ui/icons';
import React from 'react';
import { SharedDataDictionary } from './SharedDataDictionary';
import { Space } from 'antd';
import { useParams } from 'react-router-dom';
import { ViewArea } from '@ui/general';
import { useAction, useOnMount, useSonarSelector } from '@hooks';
const sharedViewSelectors = createAsyncSelectors((state) => state.core.dataDictionary.views.sharedKey.get);
export const SharedDataDictionaryView = () => {
    const { id } = useParams();
    const isIdle = useSonarSelector(sharedViewSelectors.isIdle);
    const isErrored = useSonarSelector(sharedViewSelectors.isErrored);
    const isFailed = useSonarSelector(sharedViewSelectors.isFailed);
    const isRequesting = useSonarSelector(sharedViewSelectors.isRequested);
    const data = useSonarSelector(sharedViewSelectors.data);
    const requestView = useAction(coreActions.requestGetCoreDataDictionaryViewsSharedKey);
    useOnMount(() => {
        if (id) {
            requestView({
                count: 10,
                sharedKey: id
            });
        }
    });
    if (isErrored || isFailed) {
        return (React.createElement(Space, { align: 'center', className: 'invalid-view', direction: 'vertical' },
            React.createElement(NoData, { className: 'invalid-view-empty', description: React.createElement(React.Fragment, null,
                    React.createElement("span", null, COPY_SPECIFIC.INVALID_LINK),
                    React.createElement("br", null),
                    React.createElement("span", null, COPY_SPECIFIC.CONTACT_AROVY_ADMIN)) }),
            React.createElement(PoweredByArovy, null)));
    }
    if (isIdle || (isRequesting && !data)) {
        return React.createElement(GatewayContent, null);
    }
    return (React.createElement(ViewArea, { className: 'shared-data-dictionary-view', direction: 'vertical', fullHeight: true, fullWidth: true, id: 'data-dictionary-view' },
        React.createElement(SharedDataDictionary, { data: data, loading: isRequesting, viewKey: id !== null && id !== void 0 ? id : '' })));
};
